import { containerKey } from '@/@core/vue-inversify-decorator';
import { Symbols } from '../../symbols';
export const ErrorHandlerServiceMixin = {
    inject: [containerKey],
    methods: {
        getErrorHandlerService() {
            return this[containerKey].get(Symbols.ErrorHandlerService);
        },
    },
};
